import TopNav from "./components/TopNav";
import UpdateBar from "./components/UpdateBar";
import HotRank from "./components/HotRank";
import PartitionIndex from "./components/PartitionIndex";
import DebateZone from "./components/DebateZone";
import CommentClips from "./components/CommentClips";
import UpdateFeed from "./components/UpdateFeed";
import SentimentPulse from "./components/SentimentPulse";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <TopNav />
      <main>
        <UpdateBar />
        <HotRank />
        <PartitionIndex />
        <DebateZone />
        <CommentClips />
        <UpdateFeed />
        <SentimentPulse />
      </main>
      <SiteFooter />
    </div>
  );
}